<template>
  <div>
    <div name="showData">
      <strong>{{ title }}</strong>
      <ErrorMessage :status="apiStatus.status" :customMessage="apiStatus.customMessage" />
      <div name="userlist">
        <Pagenation
          v-if="listTotal > 1"
          :index="selectedUsersIndex"
          :total="listTotal"
          :isDetail="false"
          @showOther="pagenateUserlist"
        />
        <ul v-if="tmpSelectedUser.length" class="ml-3">
          <li v-for="(userId, index) in tmpSelectedUserForList" :key="index">
            {{ getUserName(Number(userId), userList) }}
          </li>
        </ul>
        <div v-else>選択されていません</div>
        <slot></slot>
        <div>
          <b-link v-b-toggle="'usersToggle'" v-if="userList.length" @click="changeToggleStatus()">
            {{ searchButtonText }}
          </b-link>
        </div>
      </div>
    </div>

    <b-collapse id="usersToggle" v-if="userList.length">
      <ListHeader
        tableId="usersSelectTable"
        :filteredList="filteredUsers"
        textPlaceholder="名前で検索"
        :fullList="userList"
        :search="search"
        :fields="getUsersField()"
        :pagenate="pagenate"
        @updateSearch="updateSearch"
        @changePage="changePage"
      ></ListHeader>
      <b-button variant="default" @click="getUserList()">この条件で検索</b-button>

      <!-- 選択用の修了生リスト -->
      <b-form>
        <b-table
          v-if="filteredUsers.length"
          id="usersSelectTable"
          :items="filteredUsers"
          :fields="tableFields"
          :per-page="pagenate.perPage"
          :sordBy="pagenate.sortBy"
          :sortDesc="pagenate.sortDesc"
          :current-page="pagenate.currentPage"
          responsive
          small
          striped
        >
          <template v-slot:head(id) v-if="isCheckBox">
            <b-form-checkbox @click.native.stop @change="selectAll" v-model="allSelected"></b-form-checkbox>
          </template>
          <template v-slot:cell(id)="data">
            <b-form-checkbox
              v-if="isCheckBox"
              :id="'select_user_' + data.item.user_id"
              :disabled="isDisabled(data.item.user_id)"
              :value="data.item.user_id"
              name="userCheckbox"
              v-model="tmpSelectedUser"
              @change="changeSelectedUser"
            ></b-form-checkbox>
            <b-form-radio
              v-else
              :value="Number(data.item.user_id)"
              :id="'select_user_' + data.item.user_id"
              name="userSelected"
              v-model="selectedUser"
              @change="changeSelectedUser"
            ></b-form-radio>
          </template>
          <template v-slot:cell(user_name)="data">
            <label :for="'select_user_' + data.item.user_id">{{ data.item.user_name }}</label>
          </template>
          <template v-slot:cell(birth_year)="data">
            {{ data.item.birth_year ? data.item.birth_year : '未設定' }}
          </template>
        </b-table>
        <template v-else>条件に合うユーザはいません</template>
      </b-form>
    </b-collapse>
    <template v-else>利用できるユーザがいません</template>
  </div>
</template>

<script>
import api from '@/api'
import baseJs from '@/transformer/base'
import listJs from '@/transformer/list'
import { mapState } from 'vuex'

import ErrorMessage from '@/components/ErrorMessage.vue'
import ListHeader from '@/components/ListHeader'
import Pagenation from '@/components/Pagenation.vue'

export default {
  name: 'UserSelectForm',
  components: {
    ErrorMessage,
    Pagenation,
    ListHeader
  },
  props: {
    title: String,
    isCheckBox: Boolean,
    selectedUserList: Array
  },
  computed: {
    ...mapState({
      announcement: (state) => state.Announcement.announcement
    }),
    isAllSelected: function () {
      return this.filteredUsers.every((user) => {
        return this.tmpSelectedUser.indexOf(user.user_id) > -1
      })
    },

    listTotal: function () {
      return Math.floor((this.tmpSelectedUser.length - 1) / 10) + 1
    },
    searchButtonText: function () {
      if (this.showSelectform) {
        return 'ユーザ編集▲'
      }
      return 'ユーザ編集▼'
    },
    selection() {
      return baseJs.getSelectionsByObject(this.userList, false)
    },
    tmpSelectedUserForList: function () {
      return this.tmpSelectedUser.slice(this.selectedUsersIndex * 10, this.selectedUsersIndex * 10 + 10)
    },
    tableFields: function () {
      return this.getUsersField().filter((e) => !e.hidden)
    }
  },
  data: function () {
    return {
      pagenate: listJs.getDefaultPagenate(),
      filteredUsers: [],
      apiStatus: baseJs.getApiStatusEmpty(),
      prefectures: [],
      timeList: [],
      selectedUsersIndex: 0,
      search: listJs.getEmptySearch(this.getUsersField()),
      selectedUser: this.selectedUserList[0],
      showSelectform: false,
      userList: [],
      tmpSelectedUser: this.selectedUserList,
      originalSelectedUsers: this.selectedUserList,
      allSelected: false
    }
  },
  methods: {
    changeToggleStatus: function () {
      if (this.showSelectform) {
        this.showSelectform = false
      } else {
        this.showSelectform = true
      }
    },
    isDisabled: function (userId) {
      if (this.originalSelectedUsers.includes(userId)) {
        return true
      }
      return false
    },
    changeSelectedUser: function () {
      if (!this.isCheckBox) {
        // ラジオボタンなのでthis.selectedUser(単体のid)が更新されている
        this.tmpSelectedUser = [this.selectedUser]
      }
      if (this.isCheckBox) {
        // チェックボックスならthis.tmpSelectedUserが更新されている
        this.allSelected = this.isAllSelected
      }
      this.$emit('userSelected', this.tmpSelectedUser)
    },
    openUserSelectForm: function () {
      this.showSelectform = true
    },

    // 全て選択のチェックボックスクリック時。check=trueなら選択、falseなら解除
    selectAll: function (check) {
      const tmpArray = [...this.tmpSelectedUser]
      this.filteredUsers.map((user) => {
        const index = this.tmpSelectedUser.indexOf(user.user_id)
        if (index === -1 && check) {
          // 全選択の時、現在のフィルタで表示されたうち未選択のユーザを全て選択
          tmpArray.push(user.user_id)
        } else if (!check && index > -1 && this.originalSelectedUsers.indexOf(user.user_id) < 0) {
          // 選択解除の時、現在のフィルタで表示されたユーザのうち、メール未送信の全員を選択解除
          tmpArray.splice(index, 1)
        }
        this.tmpSelectedUser = tmpArray
      })

      this.$nextTick().then(() => {
        this.changeSelectedUser()
      })
    },
    updateSearch: function (e) {
      this.search = e
    },
    closeUserSelectForm: function () {
      this.showSelectform = false
    },
    pagenateUserlist(index) {
      this.selectedUsersIndex = index
    },
    changePage: function (e) {
      this.pagenate = e
    },
    getUserList: async function () {
      this.apiStatus = baseJs.getApiStatusEmpty()
      let userList = []
      await api.announcement
        .listToUser(this.search)
        .then((res) => {
          this.apiStatus = baseJs.getApiStatusSuccess()
          userList = res.list
        })
        .catch((error) => {
          this.apiStatus = baseJs.getErrorStatus(error)
        })
      this.filteredUsers = userList
      if (this.isCheckBox) {
        this.allSelected = this.isAllSelected
      }
      if (!this.userList.length) {
        this.userList = userList
      }
    },
    getUserName: function (userId, userList) {
      const data = userList.find((userData) => {
        return Number(userData.user_id) === userId
      })
      if (data && data.user_name) {
        return data.user_name
      }
      return 'ユーザ名を取得できませんでした。'
    },
    getUsersField: function () {
      return [
        { key: 'id', label: '　' },
        { key: 'user_name', label: '名前', sortable: true, textSearch: true },
        { key: 'address_prefecture', label: '都道府県', hidden: true, selectSearch: this.prefectures, multiple: true },
        { key: 'tag', label: 'タグ', hidden: true, selectSearch: this.userTags, multiple: true },
        { key: 'program_time', label: '修了年度', hidden: true, selectSearch: this.timeList, multiple: true }
      ]
    },
    getUserTags: async function () {
      const tags = await api.announcement.listUserTags()
      this.userTags = tags.list.map((prefecture) => {
        return { text: prefecture.name, value: prefecture.id }
      })
    },
    getPrefectures: async function () {
      const prefectures = await api.announcement.listPrefecture()
      this.prefectures = prefectures.list.map((prefecture) => {
        return { text: prefecture.name, value: prefecture.id }
      })
    },
    getProgramCourses: async function () {
      const times = await api.announcement.listProgramTimeAndCourse()
      this.timeList = times.program_times.map((e) => {
        return { text: e.name, value: e.id }
      })
    }
  },
  mounted: function () {
    this.getPrefectures()
    this.getUserTags()
    this.getProgramCourses()
    this.getUserList()
  },
  watch: {
    selectedUserList() {
      this.tmpSelectedUser = this.selectedUserList
    }
  }
}
</script>
